// ----------------- SUBMIT PURCHASE  -----------------
export const PURCHASE_LOADING = 'PURCHASE_LOADING';
export const PURCHASE_SUCCESS = 'PURCHASE_SUCCESS';
export const PURCHASE_ERROR = 'PURCHASE_ERROR';

// -----------------  PURCHASE CLEAR -----------------
export const PURCHASE_CLEAR = 'PURCHASE_CLEAR';
